
<b-row align-content="center">
  <b-col>
    <b-nav class="mb-4" pills small>
      <slot />
    </b-nav>
  </b-col>
</b-row>
